import TagManager from "react-gtm-module"


// ===== GTM Initialization =====
export function initGTM(): void {
  if (typeof window === "undefined") return

  const gtmId = process.env.NEXT_PUBLIC_GTM_ID
  if (!gtmId) return

  TagManager.initialize({ gtmId })
}

// ===== DataLayer Push Helper =====
function pushToDataLayer(data: Record<string, any>): void {
  if (typeof window !== "undefined" && (window as any).dataLayer) {
    ;(window as any).dataLayer.push(data)
  }
}

// ===== GA4 Custom Event Tracking =====
export function trackEvent(eventName: string, params?: Record<string, any>): void {
  pushToDataLayer({
    event: eventName,
    ...params,
  })
}

// ===== Global User ID =====
export function setGlobalUserId(userId: number): void {
  if (typeof window === "undefined") return
  ;(window as any).userId = String(userId)
  pushToDataLayer({ user_id: String(userId) })
}

export function clearGlobalUserId(): void {
  if (typeof window === "undefined") return
  ;(window as any).userId = undefined
  pushToDataLayer({ user_id: undefined })
}

// ===== Sentry Error → GA4 Bridge =====
export function trackSentryError(event: {
  event_id?: string
  exception?: { values?: Array<{ type?: string; value?: string }> }
}): void {
  const firstException = event.exception?.values?.[0]
  trackEvent("sentry_error", {
    sentry_event_id: event.event_id || "",
    error_type: firstException?.type || "Unknown",
    error_message: firstException?.value || "",
    page_url: typeof window !== "undefined" ? window.location.href : "",
  })
}
